require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-student-project-harnesses-brain-power-to-fly-ar-drone.json") })
        }
      }, "path---blog-student-project-harnesses-brain-power-to-fly-ar-drone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-student-project-harnesses-brain-power-to-fly-ar-drone!./.cache/json/blog-student-project-harnesses-brain-power-to-fly-ar-drone.json
// module id = 1080
// module chunks = 231608221292675